import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { queries } from 'src/config/queries';
import { EntityTypes } from 'src/core/services/upload/constants';
import { useCombineQueries } from 'src/shared/hooks/useCombineQueries';
export function useFillFormForUpdate(mentorshipId) {
    const { reset } = useFormContext();
    const isUpdate = Boolean(mentorshipId) && mentorshipId !== 'new';
    const [isFormLoading, setIsFormLoading] = useState(isUpdate);
    const combinedQueries = useCombineQueries([
        { ...queries.mentorships.byId(mentorshipId), enabled: isUpdate, staleTime: 0 },
        {
            ...queries.upload.filesByEntityType(mentorshipId, EntityTypes.ModuleCoverImg),
            enabled: isUpdate,
            staleTime: 0
        }
    ]);
    const [mentorship, cover] = combinedQueries.data;
    useEffect(function effectFillForm() {
        if (combinedQueries.isSuccess) {
            const { name, link, classes, publicModule, extra, imageId, mediaId } = mentorship;
            const coverFile = cover[0] ?? {};
            const values = {
                name,
                link,
                extra,
                classes,
                publicModule,
                imageId: imageId ?? null,
                mediaId: mediaId ?? null,
                cover: coverFile.id
                    ? {
                        id: coverFile.id,
                        name: coverFile.name,
                        url: coverFile.thumborSignedUrl
                    }
                    : null
            };
            reset(values);
            setIsFormLoading(false);
        }
        if (combinedQueries.isError) {
            setIsFormLoading(false);
        }
    }, [combinedQueries.isSuccess, cover, mentorship, mentorshipId, reset, combinedQueries.isError]);
    return { ...combinedQueries, isFormLoading };
}
